let open = false;

const closeOverlay = () => {
  const popupContainer = document.querySelector('#popup-container');
  popupContainer.classList.remove('is-active');
  popupContainer.innerHTML = '';
  open = false;
};

const listenIfOpen = (e) => {
  if (open && e.target.id === 'popup-container') {
    closeOverlay();
  }
};

window.openOverlay = (template) => {
  const popupContainer = document.querySelector('#popup-container');
  popupContainer.classList.add('is-active');

  if (typeof template === 'object') {
    popupContainer.appendChild(template);
  } else {
    popupContainer.innerHTML = template;
  }

  window.addEventListener('mousedown', listenIfOpen, false);
  open = true;
};

window.closeOverlay = () => {
  window.removeEventListener('mousedown', listenIfOpen);
  closeOverlay();
};
